var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('cCard',{attrs:{"icon":"fa-tasks","title":"Mijn taken","standalone":true},scopedSlots:_vm._u([{key:"body",fn:function(){return [_c('tasksTable',{attrs:{"myTasks":true}})]},proxy:true}])})}
var staticRenderFns = []

export { render, staticRenderFns }